import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.06 6.00043L8 9.05376L4.94 6.00043L4 6.94043L8 10.9404L12 6.94043L11.06 6.00043Z",
		fill: "#333333"
	})
});
export default SvgIconChevronDown;
